// @ts-ignore
const isReactNative = global?.navigator?.product === 'ReactNative';
export default isReactNative;
